import { Backdrop, CircularProgress, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';

interface LoadingBackdropProps {
  open: boolean;
  variant?: 'translucent' | 'solid';
  sx?: SxProps<Theme>;
  children?: React.ReactNode;
}

export const LoadingBackdrop = ({ open, variant = 'translucent', sx, children }: LoadingBackdropProps) => {
  return (
    <Backdrop
      open={open}
      sx={{
        flexDirection: 'column',
        color: variant === 'translucent' ? 'var(--gentian-white)' : 'var(--gentian-secondary)',
        bgcolor: variant === 'translucent' ? 'rgba(0, 0, 0, 0.7)' : 'var(--gentian-white)',
        gap: '8px',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        ...sx,
      }}
    >
      <CircularProgress color="inherit" />
      {children && (
        <Typography
          variant="body1"
          color={variant === 'translucent' ? 'var(--gentian-white)' : 'var(--gentian-black)'}
        >
          {children}
        </Typography>
      )}
    </Backdrop>
  );
};
